export default __webpack_public_path__ + "static/modal01_02-pc-f21c07c696824d338f35696ec4ef46dc.svg";